import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Pagination, Spinner } from '@/components/ui'
import { useBienContext } from '@/features/biens/BienContext'
import { fetchEntretiens } from '@/features/entretiens/entretiensSlice'

import EntretienItemTableLine from './EntretienItemTableLine'
import EntretienItemCard from './EntretienItemCard'

export default () => {
  const dispatch = useDispatch()
  const { bien } = useBienContext()
  const entretiens = useSelector( state => state.entretiens.items )
  const pagination = useSelector((state) => state.entretiens.pagination)
  const loading = useSelector( state => state.entretiens.loadingStatus.fetchList)

  useEffect(
    () => {
      if(entretiens.length == 0 && bien?.id) {
        dispatch(fetchEntretiens({bien_id: bien.id}))
      }
    },
    [bien?.id]
  )
  
  const handlePageChange = (page) => {
    // Mettre à jour les filtres avec la nouvelle page
    dispatch(fetchEntretiens({bien_id: bien.id, page}))
  }

  return (
    <div className='mb-4'>
      <h3 className="text-md font-semibold mb-2">
        Historique des entretiens de ce logement
      </h3>
      <div className="bg-primary-100 p-4 rounded-none w-full h-full"> 
        { loading && <Spinner /> }
        { !loading && (
          <>
            {/* Affiche sur petits écrans */}
            <div className="block lg:hidden">
              <div className="flex flex-wrap gap-4">
                { entretiens.length === 0 ?
                  <div className="text-center py-4 text-gray-600 italic">
                    Aucun entretien
                  </div> :
                  entretiens.map( (item, index) => <EntretienItemCard key={index} item={item} /> )
                }
              </div>
            </div>
            {/* Affichage sur écran > 768px en tableau  */}
            <div className="hidden lg:block overflow-x-auto">
              <table className="table table-zebra w-full">
                <thead>
                  <tr>
                    <th>Type d'entretien</th>
                    <th>Nom du prestataire</th>
                    <th>Date d'entretien</th>
                    <th>Montant</th>
                    <th>Statut de la facture</th>
                  </tr>
                </thead>
                <tbody>
                  { entretiens?.length == 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center py-4 text-gray-600 italic">
                        Aucun entretien
                      </td>
                    </tr>
                  ) : (
                    entretiens.map((entretien, index) =>(
                      <EntretienItemTableLine key={index} item={entretien}/>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            { pagination.totalPages > 1 && (
              <Pagination
                currentPage={pagination.currentPage}
                totalPages={pagination.totalPages}
                onPageChange={handlePageChange}
              />
            )}
          </>
        )}
      </div>
    </div>
  )
}